module.exports = __webpack_public_path__ + "static/img/jocotoco.a6e9e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jocotoco.png
// module id = G5LO
// module chunks = 1